import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f9376fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "BPMN Modeler", -1))
const _hoisted_3 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BpmnModeler = _resolveComponent("BpmnModeler")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal-content",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("button", {
        class: "close-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, "×")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BpmnModeler, {
        ref: "bpmnModeler",
        processorService: _ctx.processorService,
        inlineMode: _ctx.inlineMode,
        hasUnsavedChanges: _ctx.hasUnsavedChanges,
        onNodeSelected: _ctx.handleNodeSelected,
        onNodeDeleted: _ctx.handleNodeDeleted,
        onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('save'))),
        onModelChanged: _ctx.onModelChanged,
        onFactoryReset: _ctx.onFactoryReset
      }, null, 8, ["processorService", "inlineMode", "hasUnsavedChanges", "onNodeSelected", "onNodeDeleted", "onModelChanged", "onFactoryReset"])
    ])
  ]))
}